/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Invalid_Requirement_ProgressInputs */

const en_api_error_task_invalid_requirement_progress = /** @type {(inputs: Api_Error_Task_Invalid_Requirement_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This requirement cannot be changed manually.`)
};

const pt_br2_api_error_task_invalid_requirement_progress = /** @type {(inputs: Api_Error_Task_Invalid_Requirement_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este requisito não pode ser alterado manualmente.`)
};

/**
* | output |
* | --- |
* | "This requirement cannot be changed manually." |
*
* @param {Api_Error_Task_Invalid_Requirement_ProgressInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_invalid_requirement_progress = /** @type {((inputs?: Api_Error_Task_Invalid_Requirement_ProgressInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Invalid_Requirement_ProgressInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_invalid_requirement_progress(inputs)
	return pt_br2_api_error_task_invalid_requirement_progress(inputs)
});